import React, { useEffect, useRef } from "react";

function CheckOutsidClick({ children, onOutSideClick, event = "mouseover" }) {
  const ref = useRef(null);

  const handleOutsideClick = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      onOutSideClick?.(false);
    }
  };

  useEffect(() => {
    document.addEventListener(event, handleOutsideClick, true);
    return () => {
      document.removeEventListener(event, handleOutsideClick, true);
    };
  }, []);
  if (!children) {
    return null;
  }
  return (
    <div className="h-100" ref={ref}>
      {children}
    </div>
  );
}

export default CheckOutsidClick;
